import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {forkJoin, map, Observable, of, switchMap} from 'rxjs';
import {environment} from '../../../environments/environment';

@Injectable({providedIn: 'root'})
export class TeamService {
    constructor(private http: HttpClient) {
    }

    getTeams(year: Number): Observable<any> {
        const credentials = btoa(`${environment.username}:${environment.apikey}`);
        const headers = new HttpHeaders({
            'Authorization': `Basic ${credentials}`,
            'Accept': 'application/json'
        });

        const baseUrl = `${environment.apiUrl}/v3.2/${year}/rankings/regional/teamdetail`;

        return this.http.get<any>(`${baseUrl}?page=1`, {headers}).pipe(
            switchMap(firstPage => {
                const pageSize = firstPage.teamCountPage;
                const totalItems = firstPage.teamCountTotal;
                const totalPages = Math.ceil(totalItems / pageSize);

                // extract page 1 team details
                const allTeams = [...firstPage.teams];

                // if only one page, return
                if (totalPages === 1) {
                    return of({
                        ...firstPage,
                        teams: allTeams
                    });
                }

                // build requests for page number higher than 1
                const requests: Observable<any>[] = [];
                for (let page = 2; page <= totalPages; page++) {
                    requests.push(
                        this.http.get<any>(`${baseUrl}?page=${page}`, {headers})
                    );
                }
                // merge the arrays
                return forkJoin(requests).pipe(
                    map(responses => {
                        responses.forEach(page => {
                            if (Array.isArray(page.teams)) {
                                allTeams.push(...page.teams);
                            }
                        });

                        return {
                            ...firstPage,
                            teams: allTeams // merged full list
                        };
                    })
                );
            })
        );
    }

    getAllAvatars(year: Number): Observable<{ teamNumber: number; encodedAvatar: string }[]> {
        const credentials = btoa(`${environment.username}:${environment.apikey}`);
        const headers = new HttpHeaders({
            'Authorization': `Basic ${credentials}`,
            'Accept': 'application/json'
        });

        const baseUrl = `${environment.apiUrl}/v3.2/${year}/avatars`;

        return this.http.get<any>(`${baseUrl}?page=1`, {headers}).pipe(
            switchMap(firstPage => {
                const pageSize = firstPage.teamCountPage;
                const totalItems = firstPage.teamCountTotal;
                const totalPages = Math.ceil(totalItems / pageSize);

                const allAvatars = [...firstPage.teams];

                if (totalPages === 1) {
                    return of(allAvatars);
                }

                const requests: Observable<any>[] = [];
                for (let page = 2; page <= totalPages; page++) {
                    requests.push(this.http.get<any>(`${baseUrl}?page=${page}`, {headers}));
                }

                return forkJoin(requests).pipe(
                    map(responses => {
                        responses.forEach(p => {
                            if (Array.isArray(p.teams)) {
                                allAvatars.push(...p.teams);
                            }
                        });
                        return allAvatars;
                    })
                );
            })
        );
    }
}
